export default {
  name: "bottomFooter",
};
